<template>
  <section>
    <b-modal :active.sync="isModalActive">
      <div style="height: 100vh; text-align: left; border-radius: 5px;" class="card">
        <div class="card-header" style="height: 60px;">
          <h1 class="title" style="padding: 0.75rem;">求人ページ作成</h1>
        </div>
        <div class="scroll-window disp-scroll">
          <div>
            <b-field label="求人を選択">
              <b-select v-model=workTitleNum placeholder="">
                <option
                  v-for="(content, i) in rootContents"
                  :key=i
                  :value=i
                  >
                  {{content.sub_job}} | {{content.job}} | {{getJob(content.work_type)}}
                </option>
              </b-select>
            </b-field>
            <hr>
            <!-- 表示タグ START -->
            <b-field label="表示タグ">
              <template>
                <div v-if="displayTags.length > 0" style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                  <button class="button is-info is-small" style="margin-right: 5px; margin-top: 3px; display: block;" v-for="(tag, idx) in displayTags" :key="idx + '-tag'">
                    <span class="mdi" style="border-color: #000;"></span>
                    {{tag.name}}
                    <span class="mdi mdi-close delete-tag-btn" name="delete-tag-btn" style="margin-left:5px;" @click="unsetEmploymentPageTags(idx,false)"></span>
                  </button>
                  <button class="button is-info is-small" style="margin-top: 3px; margin-right: 3px;" @click="createdTagOpen(false)">
                    <span class="mdi" style="border-color: #000;"></span>
                    ＋
                  </button>
                </div>
                <div v-else style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                  <div style="margin-right: 10px;">タグ設定なし</div>
                  <button class="button is-info is-small" style="margin-top: 3px; margin-right: 3px;" @click="createdTagOpen(false)">
                    <span class="mdi" style="border-color: #000;"></span>
                    ＋
                  </button>
                </div>
              </template>
            </b-field>
            <b-field>
              <template v-if="isDisplayTagOpen">
                <div v-if="companyDisplayTags.length > 0" style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                    <button class="button is-small" style="margin: 4px;" v-for="(tag, idx) in companyDisplayTags" :key="idx + '-tag'" @click="setEmploymentPageTag(tag,false)">
                      <span class="mdi" style="border-color: #000;"></span>
                      {{ tag.name }}
                      <span class="mdi mdi-close delete-tag-btn" name="delete-tag-btn" style="margin-left:5px;" @click.stop="deleteEmploymentPageTag(tag)"></span>
                    </button>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen(false)">
                      <span class="mdi" style="border-color: #000;"></span>
                      ＋
                    </button>
                </div>
                <div v-else style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                    <div style="margin-right: 10px;">作成済みタグなし</div>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen(false)">
                      <span class="mdi" style="border-color: #000;"></span>
                      ＋
                    </button>
                </div>
                <div class="tag-create" v-if="isDisplayTagCreateOpen">
                  <b-field>
                    <p class="title">タグ名：</p><input class="input is-small" style="max-width: 200px; margin-right: 10px;" maxlength="15" v-model="createTagInfo.name"/>
                    <p class="title">説明：</p><input class="input is-small" style="max-width: 200px;" v-model="createTagInfo.description"/>
                  </b-field>
                  <b-field>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createEmploymentPageTag(createTagInfo,false)">
                      <p class="title">作成</p>
                    </button>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen(false)">
                      <p class="title">キャンセル</p>
                    </button>
                  </b-field>
                </div>
              </template>
            </b-field>
            <!-- 表示タグ END -->
            <hr>
            <!-- 管理タグ START -->
            <b-field label="管理タグ">
              <template>
                <div v-if="manageTags.length > 0" style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                  <button class="button is-info is-small" style="margin-right: 5px; margin-top: 3px; display: block;" v-for="(tag, idx) in manageTags" :key="idx + '-tag'">
                    <span class="mdi" style="border-color: #000;"></span>
                    {{tag.name}}
                    <span class="mdi mdi-close delete-tag-btn" name="delete-tag-btn" style="margin-left:5px;" @click="unsetEmploymentPageTags(idx,true)"></span>
                  </button>
                  <button class="button is-info is-small" style="margin-top: 3px; margin-right: 3px;" @click="createdTagOpen(true)">
                    <span class="mdi" style="border-color: #000;"></span>
                    ＋
                  </button>
                </div>
                <div v-else style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                  <div style="margin-right: 10px;">タグ設定なし</div>
                  <button class="button is-info is-small" style="margin-top: 3px; margin-right: 3px;" @click="createdTagOpen(true)">
                    <span class="mdi" style="border-color: #000;"></span>
                    ＋
                  </button>
                </div>
              </template>
            </b-field>
            <b-field>
              <template v-if="isManageTagOpen">
                <div v-if="companyManageTags.length > 0" style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                    <button class="button is-small" style="margin: 4px;" v-for="(tag, idx) in companyManageTags" :key="idx + '-tag'" @click="setEmploymentPageTag(tag,true)">
                      <span class="mdi" style="border-color: #000;"></span>
                      {{ tag.name }}
                      <span class="mdi mdi-close delete-tag-btn" name="delete-tag-btn" style="margin-left:5px;" @click.stop="deleteEmploymentPageTag(tag)"></span>
                    </button>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen(true)">
                      <span class="mdi" style="border-color: #000;"></span>
                      ＋
                    </button>
                </div>
                <div v-else style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                    <div style="margin-right: 10px;">作成済みタグなし</div>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen(true)">
                      <span class="mdi" style="border-color: #000;"></span>
                      ＋
                    </button>
                </div>
                <div class="tag-create" v-if="isManageTagCreateOpen">
                  <b-field>
                    <p class="title">タグ名：</p><input class="input is-small" style="max-width: 200px; margin-right: 10px;" maxlength="15" v-model="createTagInfo.name"/>
                    <p class="title">説明：</p><input class="input is-small" style="max-width: 200px;" v-model="createTagInfo.description"/>
                  </b-field>
                  <b-field>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createEmploymentPageTag(createTagInfo,true)">
                      <p class="title">作成</p>
                    </button>
                    <button class="button is-small" style="margin-top: 3px; margin-right: 3px;" @click="createTagOpen(true)">
                      <p class="title">キャンセル</p>
                    </button>
                  </b-field>
                </div>
              </template>
            </b-field>
            <!-- 管理タグ END -->
            <hr>
            <img style="width: 100%; height: 250px; object-fit: cover;" :src="getImageURL()"/>
            <hr>
            <b-field label="画像を選択">
              <div class="parent-box">
                <div class="box-request">
                  画像を下記から選ぶことができます（<a href="https://unsplash.com/">Unsplash</a>）
                  <div style="width: 100%; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('job')">仕事1</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('work')">仕事2</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('meeting')">仕事3</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('care')">介護・福祉・リハビリ1</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('health')">介護・福祉・リハビリ2</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('elderly care')">介護・福祉・リハビリ3</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('nurse')">医療</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('sales')">営業</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('shop')">販売</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('education')">教育</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('designer')">デザイン</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('hotel')">旅行・ホテル</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('real estate')">不動産</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('finance')">金融</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('transportation')">運輸・輸送</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('programming')">IT・Web</button>
                    <button class="button is-small is-primary" style="margin: 4px;" @click="searchPhotos('engineer')">エンジニア</button>
                  </div>
                  <hr>
                  <ul class="horizontal-image disp-scroll">
                    <li v-for="photo in photos" :key="photo.id">
                      <img @click="saveImageAPI(photo)" class="image-list" height="200" width="300" :src="photo.urls.thumb" alt="img"/>
                    </li>
                  </ul>
                  <hr>
                  <b-field position="is-centered" style="text-align: center !important;">
                    <div class="upload-form">
                      <a class="upload-style">
                        <label for="file_upload" class="upload-style">
                          <a class="button is-primary"
                          @click="openSelectModal">
                            <span class="mdi mdi-image" style="margin-right: 10px;"></span>メディア倉庫から画像を選択する
                          </a>
                          <!-- <input type="file" id="file_upload" @change="onFileChange"> -->
                          <ModalSelectMedia @updated="selectImage"></ModalSelectMedia>
                        </label>
                      </a>
                    </div>
                  </b-field>
                </div>
              </div>
            </b-field>
            <b-field class="job-detail" label="募集タイトル">
              <input v-model="currentContent.title" class="input" placeholder=""/>
            </b-field>
            <b-field class="job-detail" label="雇用形態">
              <p style="padding: 5px; border: solid thin #ccc; border-radius: 5px;">{{getJob(currentContent.work_type)}}</p>
            </b-field>
            <b-field class="job-detail" label="職種（大項目）">
              <input v-model="currentContent.work_category" class="entered input" placeholder=""/>
            </b-field>
            <b-field class="job-detail" label="職種（小項目）">
              <input v-model="currentContent.work_title" class="entered input" placeholder=""/>
            </b-field>
            <b-field class="job-detail" label="仕事内容">
              <textarea v-model="currentContent.work_content" class="textarea" placeholder=""></textarea>
            </b-field>
            <b-field class="job-detail" label="応募資格・条件・求める人材">
              <textarea v-model="currentContent.wanted_person" class="textarea" placeholder=""></textarea>
            </b-field>
            <b-field class="job-detail" label="勤務地">
              <div>
                <div style="float:left">
                  <b-select v-model="changeTopSelected" placeholder="">
                    <option :value="null">　</option>
                    <option
                      v-for="(topdepartment, i) in topDepartments"
                      :key=i
                      :value=topdepartment.pk
                      >
                      {{topdepartment.name}}
                    </option>
                  </b-select>
                </div>
                <div style="float:left">
                  <b-select v-model="changeSecondSelected" placeholder="">
                    <option :value="null">　</option>
                    <option
                      v-for="(seconddepartment, i) in secondDepartments"
                      :key=i
                      :value=seconddepartment.pk
                      >
                      {{seconddepartment.name}}
                    </option>
                  </b-select>
                </div>
                <div style="float:left">
                  <b-select v-model="changeThirdSelected" placeholder="">
                    <option :value="null">　</option>
                    <option
                      v-for="(thirddepartment, i) in thirdDepartments"
                      :key=i
                      :value=thirddepartment.pk
                      >
                      {{thirddepartment.name}}
                    </option>
                  </b-select>
                </div>
                <textarea v-model="currentContent.location" class="entered textarea" placeholder=""></textarea>
              </div>
            </b-field>
            <b-field class="job-detail" label="勤務時間">
              <textarea v-model="currentContent.work_time" class="entered textarea" placeholder="（例）9:00-18:00"></textarea>
            </b-field>
            <b-field class="job-detail" label="給与">
              <textarea v-model="currentContent.salary" class="entered textarea" placeholder=""></textarea>
            </b-field>    
            <b-field class="job-detail" label="休日休暇">
              <textarea v-model="currentContent.holiday" class="entered textarea" placeholder="（例）完全週休2日制"></textarea>
            </b-field>        
            <b-field class="job-detail" label="福利厚生">
              <textarea v-model="currentContent.welfare" class="entered textarea" placeholder=""></textarea>
            </b-field>        
            <b-field class="job-detail" label="選考フロー">
              <textarea v-model="currentContent.selection_flow" class="entered textarea" placeholder=""></textarea>
            </b-field>
            <b-field class="location-info-container" label="勤務地">
              <div class="location-info-wrapper">
                <div class="location-info">
                  <p class="location-info -name">郵便番号</p><input v-model="currentContent.address.postalcode" placeholder="郵便番号を入力" maxlength="8" class="entered input" id="zipcode"/>
                </div>
                <div class="location-info">
                  <p class="location-info -name">都道府県 </p><input v-model="currentContent.address.region" placeholder="都道府県を入力" class="entered input"/>
                </div>
                <div class="location-info">
                  <p class="location-info -name">市町村区</p><input v-model="currentContent.address.locality" placeholder="市町村区を入力" class="entered input"/>
                </div>
                <div class="location-info">
                  <p class="location-info -name">番地等</p><input v-model="currentContent.address.street" placeholder="それ以降の住所を入力" class="entered input"/>
                </div>
              </div>
            </b-field>
            <b-field class="location-info-container" label="応募通知先">
              <div>
                <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;">
                  入力例に従って、応募通知を送信したいメールアドレスを「,」区切りで入力してください。
                </p>
                <div style="display: flex; flex-wrap: wrap; margin-top: 8px;">
                  <input v-model="currentContent.notification_destination" placeholder="aaa@robottte.com,bbb@robottte.com" class="entered input"/>
                </div>
              </div>
            </b-field>
          </div>
          <div class="button-container">
            <button @click="makePage" class="entered_btn button is-large is-rounded" :disabled="enteredFlg === false">作成</button>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import { Core as YubinBangoCore } from 'yubinbango-core'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import { get } from 'lodash'

export default {
  components: {
    Multiselect,
    ModalSelectMedia
  },
  computed: {
    ...mapState('auth', ['user','users','departments']),
    ...mapState('employmentPage', ['rootContents','companyDisplayTags','companyManageTags']),
    ...mapState('mediapool', ['images']),

    topDepartments: function () {
      return this.departments.filter(function (department) {
        return  department.department === null
      })
    },
    secondDepartments: function () {
      let tmpTopSelected = this.topSelected
      if(this.topSelected != null) {
        return this.departments.filter(function (department) {
          return department.department === tmpTopSelected
        })
      } else {
        return null
      }
    },
    thirdDepartments: function () {
      let tmpSecondSelected = this.secondSelected
      if(this.secondSelected != null) {
        return this.departments.filter(function (department) {
          return department.department === tmpSecondSelected
        })
      } else {
        return null
      }
    },
    changeTopSelected: {
      get() {
        return this.topSelected
      },
      set(newval) {
        this.topSelected = newval
        this.secondSelected = null
        this.thirdSelected = null
        const dep1 = this.departments.filter(department => department.pk == newval)
        if(dep1.length > 0) {
          this.currentContent.location = dep1[0].name || ""
          this.currentContent.address.postalcode = dep1[0].postal_code || ""
          this.currentContent.address.region = dep1[0].region || ""
          this.currentContent.address.locality = dep1[0].locality || ""
          this.currentContent.address.street = dep1[0].street || ""
        } else {
          this.currentContent.location = ""
          this.currentContent.address.postalcode = ""
          this.currentContent.address.region = ""
          this.currentContent.address.locality = ""
          this.currentContent.address.street = ""
        }
      }
    },
    changeSecondSelected: {
      get() {
        return this.secondSelected
      },
      set(newval) {
        this.secondSelected = newval
        this.thirdSelected = null
        const dep2 = this.departments.filter(department => department.pk == newval)
        if(dep2.length > 0) {
          this.currentContent.location = dep2[0].name || ""
          this.currentContent.address.postalcode = dep2[0].postal_code || ""
          this.currentContent.address.region = dep2[0].region || ""
          this.currentContent.address.locality = dep2[0].locality || ""
          this.currentContent.address.street = dep2[0].street || ""
        }
      }
    },
    changeThirdSelected: {
      get() {
        return this.thirdSelected
      },
      set(newval) {
        this.thirdSelected = newval
        const dep3 = this.departments.filter(department => department.pk == newval)
        if(dep3.length > 0) {
          this.currentContent.location = dep3[0].name || ""
          this.currentContent.address.postalcode = dep3[0].postal_code || ""
          this.currentContent.address.region = dep3[0].region || ""
          this.currentContent.address.locality = dep3[0].locality || ""
          this.currentContent.address.street = dep3[0].street || ""
        }
      }
    }
  },
  mounted () {
    this.searchPhotos('job')
  },
  data () {
    return {
      isModal: false,
      search: '',
      photos: [],
      isModalActive: false,
      enteredFlg: false,
      workTitleNum: '',
      image: null,
      is_image_original: false,
      image_url: '',
      image_unsplash: null,
      // 求人原稿のcontent部分の入力情報を受け取るオブジェクト
      currentContent: {
        title: '',
        work_type: '',
        work_category: '',
        work_title: '',
        work_content: '',
        wanted_person: '',
        location: '',
        work_time: '',
        salary: '',
        holiday: '',
        welfare: '',
        selection_flow: '',
        address: {
          postalcode: '',
          region: '',
          locality: '',
          street: ''
        },
        google_map: '',
        notification_destination: '',
      },
      workType: [
        {
          name: 'FULL_TIME',
          jobname: '正社員'
        },
        {
          name: 'PART_TIME',
          jobname: 'アルバイト'
        },
        {
          name: 'CONTRACTOR',
          jobname: '契約社員'
        },
        {
          name: 'INTERN',
          jobname: 'インターン'
        },
        {
          name: 'OTHER',
          jobname: 'その他'
        }
      ],
      zip: null,
      pref_id: null,
      locality: null,
      street: null,
      // 組織状態の選択状態を管理する変数
      topSelected: null,
      secondSelected: null,
      thirdSelected: null,
      // タグの選択状態を管理する変数
      displayTags: [],
      manageTags: [],
      // 作成済み状態の開閉状態を管理する変数
      isDisplayTagOpen: false,
      isManageTagOpen: false,
      // タグの作成スペースの開閉状態を管理する変数
      isDisplayTagCreateOpen: false,
      isManageTagCreateOpen: false,
      // タグ作成時の入力情報受け取るオブジェクト
      createTagInfo: {
        name: "",
        description: "",
      }
    }
  },
  watch: {
    'currentContent.address.postalcode' (newVal) {
      if (newVal.length >= 7) {
        new YubinBangoCore(newVal, (addr) => {
          if(addr.region) {
            this.currentContent.address.region = addr.region // 都道府県
          } else {
            alert('ご指定の郵便番号では住所が見つかりませんでした')
          }
          if(addr.locality) {
            this.currentContent.address.locality = addr.locality + addr.street // 市区町村
          }
        })
      }
    },
    workTitleNum () {
      this.currentContent.work_type = this.rootContents[this.workTitleNum].work_type
      this.currentContent.work_category = this.rootContents[this.workTitleNum].job
      this.currentContent.work_title = this.rootContents[this.workTitleNum].sub_job
      this.currentContent.location = this.rootContents[this.workTitleNum].location
      this.currentContent.work_time = this.rootContents[this.workTitleNum].work_time
      this.currentContent.salary = this.rootContents[this.workTitleNum].salary
      this.currentContent.holiday = this.rootContents[this.workTitleNum].holiday
      this.currentContent.welfare = this.rootContents[this.workTitleNum].welfare
      this.currentContent.selection_flow = this.rootContents[this.workTitleNum].selection_flow
      this.currentContent.address.postalcode = this.rootContents[this.workTitleNum].postal_code
      this.currentContent.address.region = this.rootContents[this.workTitleNum].region
      this.currentContent.address.locality = this.rootContents[this.workTitleNum].locality
      this.currentContent.address.street = this.rootContents[this.workTitleNum].street
      this.currentContent.google_map = this.rootContents[this.workTitleNum].region + this.rootContents[this.workTitleNum].locality + this.rootContents[this.workTitleNum].street
    },
    currentContent: {
      handler: function (content) {
        var array = [
          content.work_category,
          content.work_title,
          content.work_content,
          content.wanted_person,
          content.location,
          content.work_time,
          content.salary,
          content.holiday,
          content.welfare,
          content.selection_flow,
          content.address.postalcode,
          content.address.region,
          content.address.locality,
          content.address.street
        ]
        for (var v of array) {
          if (v === '') {
            this.enteredFlg = false
            break
          } else {
            this.enteredFlg = true
          }
        }
      },
      deep: true
    }
  },
  methods: {
    // タグ作成スペースの表示制御処理
    createTagOpen(manageFlg) {
      // manageFlg True＝管理タグ False＝表示タグ
      if(manageFlg){
        this.isManageTagCreateOpen = !this.isManageTagCreateOpen
      } else {
        this.isDisplayTagCreateOpen = !this.isDisplayTagCreateOpen
      }
    },
    // 作成済みタグの表示制御処理
    createdTagOpen(manageFlg){
      // manageFlg True＝管理タグ False＝表示タグ
      if(manageFlg){
        this.isManageTagOpen = !this.isManageTagOpen
      }else{
        this.isDisplayTagOpen = !this.isDisplayTagOpen
      }
    },
    // 選択されたタグをセットする処理
    setEmploymentPageTag(tag,manageFlg){
      // manageFlg True＝管理タグ False＝表示タグ
      if(manageFlg){
        // manageTagsにtagがまだ存在しない場合のみpushする
        if (!this.manageTags.some(existingTag => existingTag.id === tag.id)) {
          this.manageTags.push(tag)
        }
      }else{
        // displayTagsにtagがまだ存在しない場合のみpushする
        if (!this.displayTags.some(existingTag => existingTag.id === tag.id)) {
          this.displayTags.push(tag)
          console.log("this.displayTags:",this.displayTags)
        }
      }
    },
    // 求人原稿に設定されているタグを解除する処理
    unsetEmploymentPageTags(idx,manageFlg){
      // manageFlgがTrue＝管理タグ、False＝表示タグ
      if(manageFlg){
        // manageTagsからインデックスがidxの要素を1つ削除
        this.manageTags.splice(idx, 1)
      }else{
        // displayTagsからインデックスがidxの要素を1つ削除
        this.displayTags.splice(idx, 1)
      }
    },
    // 求人原稿タグの作成処理
    async createEmploymentPageTag(tagInfo,manageFlg){
      const createTagData = {
        name: tagInfo.name,
        description: tagInfo.description,
        is_manage: manageFlg,
      }
      // タグ名重複チェックの為に、manageFlgに応じた作成済みタグ情報を格納
      const existingTags = manageFlg ? this.companyManageTags : this.companyDisplayTags
      // タグ名重複チェック
      const isTagExists = existingTags.some(tag => tag.name === createTagData.name)
      if (isTagExists) {
        // 既存のタグと名前が一致する場合はreturn
        alert("このタグ名は既に存在します。別の名前を入力してください。")
        return
      }
      // 既存のタグとタグ名の重複がなければ新しいタグを作成
      await this.$store.dispatch('employmentPage/createEmploymentPageTag',createTagData)
        .then((response) => {
          // 入力値の初期化
          tagInfo.name = ""
          tagInfo.description = ""
        })
    },
    // 求人原稿タグを削除する処理
    async deleteEmploymentPageTag(tag){
      // 削除確認
      if (confirm(`「${tag.name}」のデータを削除してもよろしいですか？`)) {
        // OKの場合のみ削除処理を実行
        await this.$store.dispatch('employmentPage/deleteEmploymentPageTag', tag.id)
          .then((response) => {
            // 現在の選択状態からも削除
            if (tag.is_manage) {
              this.manageTags = this.manageTags.filter(t => t.id !== tag.id);
            } else {
              this.displayTags = this.displayTags.filter(t => t.id !== tag.id);
            }
          })
      }
    },
    getImageURL () {
      console.debug('Start getImageURL')
      var url = ''
      // if (this.is_image_original) url = this.image
      // else url = this.image_url
      if (this.is_image_original) {
        for (var idx=0; idx < this.images.length; idx++) {
          if (this.images[idx].image_id == this.image) {
            url = this.images[idx].path
            break
          }
        }
      } else {
        if (this.image_unsplash) {
          url = this.image_unsplash.urls['regular'] ? this.image_unsplash.urls.regular : this.image_unsplash.urls.raw
        } else {
          url = this.image_url
        }
      }
      var defaultURL = require('@/assets/template/default_recruit.jpg')
      if (url == '') return defaultURL
      else return url
    },
    searchPhotos (search) {
      console.debug('Start searchPhotos')
      console.debug('search: ' + search)
      let appid = this.$unsplash._applicationId
      let query  = search
      this.$axios.get(`https://api.unsplash.com/search/photos/?page=1&per_page=30&query=${query}&client_id=${appid}&width=1920&height=1080`)
      .then(response => {
        this.photos = response.data.results
      })
      .catch(e => {
        console.log(e)
      })
      console.debug('End searchPhotos')
    },
    makeUploadLabel (index) {
      console.debug('Start makeUploadLabel')
      console.debug('index: ' + index)
      return "file_upload" + index
    },
    // onFileChange (e) {
    //   console.debug('Start onFileChange')
    //   console.debug('e: ' + e)
    //   let files = e.target.files || e.dataTransfer.files
    //   let reader = new FileReader()
    //   reader.onload = (e) => {
    //     this.image = e.target.result
    //     this.is_image_original = true
    //   }
    //   reader.readAsDataURL(files[0])
    //   this.isModal = false
    //   console.debug('End onFileChange')
    // },
    openSelectModal(){
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    selectImage(id){
      this.image = id
      this.is_image_original = true
      this.isModal = false
    },
    saveImageAPI (photo) {
      console.debug('Start saveImageAPI')
      this.image_unsplash = photo
      this.is_image_original = false
      console.debug('End saveImageAPI')
    },
    // 求人原稿作成
    makePage () {
      var image_data = null
      if (this.is_image_original) image_data = this.image.replace(/^.*,/, '')
      else image_data = this.image_unsplash
      const displayTagIds = this.displayTags.map(tag => tag.id)
      const manageTagIds = this.manageTags.map(tag => tag.id)
      // content内のgooglemap情報(求人ページ上の「アクセス」)の内容の更新
      this.currentContent.google_map = this.currentContent.address.region + this.currentContent.address.locality + this.currentContent.address.street
      var setJson = {
        content: this.currentContent,
        is_image_original: this.is_image_original,
        'image_data': image_data,
        'top_department': this.changeTopSelected,
        'second_department': this.changeSecondSelected,
        'third_department': this.changeThirdSelected,
        'display_tags': displayTagIds,
        'manage_tags': manageTagIds,
      }
      this.$store.dispatch('employmentPage/postContentsRecruit', {content: setJson, pages: this.$route.query.pages ? this.$route.query.pages : 1, layout: 4})
      alert('作成いたしました')
      this.isModalActive = false
    },
    getJob (name) {
      switch (name) {
        case 'FULL_TIME':
          return '正社員'
          break
        case 'PART_TIME':
          return 'アルバイト'
          break
        case 'CONTRACTOR':
          return '契約社員'
          break
        case 'INTERN':
          return 'インターン'
          break
        case 'OTHER':
          return 'その他'
          break
        default:
          return 'その他'
      }
    }
  }
}
</script>

<style scoped>
.scroll-window {
  width: 100%;
  height: calc(100% - 60px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 32px;
  padding-top: 16px;
  position: relative;
}
.keyword {
  margin-top: 32px;
}
.button-container {
  margin: 40px 0 32px 0;
  width: 100%;
  text-align: center;
}
.entered {
  background-color: floralwhite !important;
}
.entered_btn {
  background: #ee2c98;
  color: #fff;
}

.upload-form {
  position: relative;
}
.upload-style {
  width: 200px;
  border-radius: 10px;
}
.upload-style > input {
  display: none;
}

.parent-box {
  display: flex;
  justify-content: space-around;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.horizontal-image {
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  height: 300px;
  width: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.horizontal-image li {
  background: #fff;
  margin: 2px;
  text-align: center;
  width: 230px;
}
.image-list {
  width: 230px;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
}
.location-info > input{
  width: calc(100% - 150px);
  padding-left: 8px;
  margin-right: 128px;
}
.location-info > p{
  width: 130px;
  margin-right: 8px;
  margin-left: 128px;
  margin-bottom: 0;
}
.location-info{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
}
.tag-create {
  border: 1px solid;
  width: 540px;
  padding: 8px;
  .title {
    font-size: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ui/ModalCreatePage.vue